import { NavLink, Link } from "react-router-dom";
import { Home, TestTubes, CalendarCheck, MessageCircle, Phone } from "lucide-react";
import { waLink, telLink, SITE } from "../data/siteConfig";

const FloatingActions = () => (
  <>
    <a
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-24 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl transition-transform duration-200 hover:scale-110 md:bottom-8 md:right-6"
    >
      <MessageCircle size={26} aria-hidden="true" />
    </a>

    <nav
      className="fixed inset-x-0 bottom-0 z-50 border-t border-gray-200 bg-white pb-[env(safe-area-inset-bottom)] md:hidden"
      aria-label="Quick actions"
      data-testid="mobile-bottom-bar"
    >
      <div className="grid grid-cols-5">
        <NavLink
          to="/"
          data-testid="bottom-nav-home"
          className={({ isActive }) =>
            `flex min-h-[56px] flex-col items-center justify-center gap-0.5 text-[11px] font-medium ${
              isActive ? "text-[#1E88E5]" : "text-slate-500"
            }`
          }
        >
          <Home size={20} aria-hidden="true" />
          Home
        </NavLink>
        <NavLink
          to="/tests"
          data-testid="bottom-nav-tests"
          className={({ isActive }) =>
            `flex min-h-[56px] flex-col items-center justify-center gap-0.5 text-[11px] font-medium ${
              isActive ? "text-[#1E88E5]" : "text-slate-500"
            }`
          }
        >
          <TestTubes size={20} aria-hidden="true" />
          Tests
        </NavLink>
        <Link
          to="/book-a-test"
          data-testid="bottom-nav-book"
          className="flex min-h-[56px] flex-col items-center justify-center gap-0.5 bg-[#1E88E5] text-[11px] font-semibold text-white"
        >
          <CalendarCheck size={20} aria-hidden="true" />
          Book
        </Link>
        <a
          href={waLink()}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="bottom-nav-whatsapp"
          className="flex min-h-[56px] flex-col items-center justify-center gap-0.5 text-[11px] font-medium text-[#1eb856]"
        >
          <MessageCircle size={20} aria-hidden="true" />
          WhatsApp
        </a>
        <a
          href={telLink}
          data-testid="bottom-nav-call"
          aria-label={`Call ${SITE.phone}`}
          className="flex min-h-[56px] flex-col items-center justify-center gap-0.5 text-[11px] font-semibold text-[#0B3056]"
        >
          <Phone size={20} aria-hidden="true" />
          Call
        </a>
      </div>
    </nav>
  </>
);

export default FloatingActions;
